import { Component, Input, Output, EventEmitter, OnInit, ViewChildren, QueryList, type OnDestroy } from '@angular/core';
import { Timesheet } from '../timesheet/timesheet.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivityService } from '../../services/acitvity.service';
import { CategoryService } from '../../services/category.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DatePipe, formatDate, type Time } from '@angular/common';
import { UserService } from '../../services/user.service';
import { UserDTO } from '../user/user.model';
import { ExportExcel } from '../../constant/ExcelExport';
import { saveAs } from 'file-saver';
import moment, { duration } from 'moment';
import { TimesheetService } from '../../services/timesheet.service';
import { TIMESHEET_STATUS, TIMESHEET_STATUS_ALL_UN_VERIFIED, TIMESHEET_STATUS_ALL_VERIFIED, TIMESHEET_STATUS_UN_VERIFIED, TIMESHEET_STATUS_VERIFIED } from '../../constant/constant';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { ActivatedRoute } from '@angular/router';
import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { ResponseBase } from '../../constant/response';
import { HttpErrorResponse } from '@angular/common/http';
import { MultiSelectSearch } from '../../helper/MultiSelectSearch';
import { ResponseCommonForList } from '../../dtos/ResponseDTOs';
import { Category } from '../../dtos/Category';
import { Activity } from '../../dtos/Activity';
import { IdName } from '../../dtos/IdName';
import { RoleEnum } from '../../enums/role.enum';


const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-timesheet-list',
  templateUrl: './timesheet-list.component.html',
  styleUrls: ['./timesheet-list.component.css'],
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class TimesheetListComponent implements OnInit {

  // [x: string]: any;
  totalItemsCount: number = 0;
  timesheets: Timesheet[] = [];
  // filters: any;
  pageSize = 10;
  currentPage = 0;
  isAdmin: boolean = false;
  isTeamlead: boolean = false;
  userList: UserDTO[] = [];
  isDepartmentAdmin: boolean = false;

  usersForFilter: IdName[] = [];
  pageIndex = 0;
  length = 0;
  displayedColumns: string[] = ['workDate', 'categoryId', 'activityId', 'workDone', 'noOfHours', 'status', 'verifiedBy', 'verifiedOn', 'actions'];
  adminDisplayedColumns: string[] = ['select', 'workDate', 'categoryId', 'activityId', "userName", 'fullName', 'workDone', 'noOfHours', 'status', 'verifiedBy', 'verifiedOn', 'actions'];
  teamleadDisplayedColumns: string[] = ['select', 'workDate', 'categoryId', 'activityId', "userName", 'fullName', 'workDone', 'noOfHours', 'status', 'verifiedBy', 'verifiedOn', 'edit', 'actions'];
  dataSource = new MatTableDataSource<Timesheet>([]);
  @Output() isExcelBeingDownloaded = new EventEmitter<boolean>();
  today: Date = new Date()
  filterForm: FormGroup;
  userData: any
  filterActivityList: Activity[] = [];
  categoryList: Category[] = [];
  activities: Activity[] = [];
  minDate: Date = new Date();
  @Input() isExcelExporting: any
  isSelectAll: boolean = false;
  timeSheetStatus: IdName[] = TIMESHEET_STATUS;

  categorySearch: MultiSelectSearch<IdName>;
  activitySearch: MultiSelectSearch<IdName>;
  userSearch: MultiSelectSearch<IdName>;
  statusSearch: MultiSelectSearch<IdName>;

  constructor(public datePipe: DatePipe, private userService: UserService, private exportData: ExportExcel,
    private formBuilder: FormBuilder, private timesheetService: TimesheetService, private activityService: ActivityService,
    private categoryService: CategoryService, private snackBar: MatSnackBar, private route: ActivatedRoute) {
    this.filterForm = this.formBuilder.group({
      workDate: [''],
      categoryIds: [[], ],
      activityIds: [[], ],
      userIds: [[], ],
      status: [[], ],
      startDate: [''],
      endDate: [''],
    });

    this.categorySearch = new MultiSelectSearch<IdName>(this.filterForm.get('categoryIds') as FormControl, [], (value) => this.onfilterCategorySelection(value));
    this.activitySearch = new MultiSelectSearch<IdName>(this.filterForm.get('activityIds') as FormControl,[]);
    this.userSearch = new MultiSelectSearch<IdName>(this.filterForm.get('userIds') as FormControl, []);
    this.statusSearch = new MultiSelectSearch<IdName>(this.filterForm.get('status') as FormControl, this.timeSheetStatus);
  }

  ngOnInit(): void {
    // this.dataSource.sort = this.sort;
    // this.dataSource.paginator = this.paginator;
    this.getStorageData();
    this.filterForm.get("startDate")?.reset();
    this.filterForm.get("endDate")?.reset();
    this.getAllCategory();
    // if(this.isAdmin || this.isTeamlead){
    //   // this.getAllUsers();
    //   this.getAllUserForFilter();
    // }
    this.getAllUserIdNameForFilter();
    this.filterForm.get("startDate")?.setValue(moment());
    this.filterForm.get("endDate")?.setValue(moment());
    this.filterDate();
    this.route.queryParams.subscribe(params => {
      if (params['userId']) {
        this.filterForm.patchValue({ userIds: [Number(params['userId'])] });
      }
      if (params['workDate']) {
        this.filterForm.patchValue({ startDate: new Date(params['workDate']) });
        this.filterForm.patchValue({ endDate: new Date(params['workDate']) });
      }
    });
    this.getTimesheets();
  }

  day = this.minDate.getDay();


  filterDate(): void {
    if (this.day <= 3) {
      this.minDate.setDate(this.today.getDate() - 4);
    } else {
      this.minDate.setDate(this.today.getDate() - 3);
    }
  }

  currentDate = new Date();
  formatedDate: string | null = this.datePipe.transform(this.currentDate, 'dd_MM_yyyy_HH_mm');
  getAllUsers(): void {
    this.userService.getAllUsers(this.userData.id, 1, 500).subscribe(
      (res: any) => {
        if (Array.isArray(res.responseObject.responseData)) {
          this.userList = res.responseObject.responseData.map((user: UserDTO) => ({
            ...user,
          }));
        } else {
          this.snackBar.open('Error fetching users: Invalid response format', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  getAllUserIdNameForFilter(): void {
    this.userService.getUserIdNameList().subscribe({
      next: (res: ResponseCommonForList<IdName>) => {
        this.usersForFilter = res.responseObject;
        this.userSearch.setOptions(this.usersForFilter);
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting UserIdNameList for Filter", err.message);
      }
    });
  }

  getCategoryName(categoryId: number) {
    return this.categoryList.find(cat => cat.id == categoryId)?.name;
  }

  getAllCategory(): void {
    this.categoryService.getAllCategory().subscribe({
      next: (res: ResponseCommonForList<Category>) => {
        this.categoryList = res.responseObject;
        this.categorySearch.setOptions(this.categoryList.map((c: IdName) => ({ id: c.id, name: c.name })));
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting List of Category", err.message);
      }
    });
  }

  getStorageData() {
    let user: any = sessionStorage.getItem("userData");
    this.userData = JSON.parse(user);
    this.isAdmin = Number(this.userData.roleId) == RoleEnum.ADMIN;
    this.isTeamlead = Number(this.userData.roleId) == RoleEnum.TEAMLEAD;
    this.isDepartmentAdmin = Number(this.userData.roleId) == RoleEnum.DEPARTMENT_ADMIN;
  }

  getTimesheets(): void {
    const filterData = this.filterForm.value;
    filterData.workDate = this.datePipe.transform(filterData.workDate, 'yyyy-MM-dd');
    filterData.startDate = this.datePipe.transform(filterData.startDate, 'yyyy-MM-dd');
    filterData.endDate = this.datePipe.transform(filterData.endDate, 'yyyy-MM-dd');
    filterData.userIds = this.filterForm.get('userIds')?.value;

    if (!this.isAdmin && !this.isTeamlead && !this.isDepartmentAdmin) {
      // if(!this.isDepartmentAdmin) {
      filterData.userIds = [this.userData.id];
      // }
    }
    this.timesheetService.getTimesheetList(filterData, this.currentPage, this.pageSize)
      .subscribe(response => {
        if (response.responseObject == undefined) {
          this.timesheets = [];
          this.totalItemsCount = 0;
          this.snackBar.open('No Data Found', 'Close', { duration: 3000 });
        } else {
          this.timesheets = response.responseObject.timesheetExportDTOList;
          this.totalItemsCount = response.responseObject.totalCounts;
          if (this.timesheets) {
            for (let index = 0; index < this.timesheets.length; index++) {
              this.timesheets[index].completed = false

            }
          }
        }
        this.dataSource.data = [...this.timesheets];
        // this.snackBar.open(response.message, 'Close', {
        //   duration: 3000,
        //   verticalPosition: 'bottom',
        //   horizontalPosition:'center'
        // });
      }, error => {
        this.snackBar.open(error.message, 'Close', { duration: 3000 });
      });
  }

  exportTimesheet(): void {
    let userId = this.userData.id;
    const filterData = this.filterForm.value;
    filterData.workDate = this.datePipe.transform(filterData.workDate, 'yyyy-MM-dd');
    filterData.startDate = this.datePipe.transform(filterData.startDate, 'yyyy-MM-dd');
    filterData.endDate = this.datePipe.transform(filterData.endDate, 'yyyy-MM-dd');
    filterData.userIds = this.filterForm.get('userIds')?.value;
    if (this.isAdmin) {
      userId = -1;
    }
    if (!this.isAdmin && !this.isTeamlead && !this.isDepartmentAdmin) {
      filterData.userIds = [this.userData.id];
    }
    this.isExcelBeingDownloaded.emit(true);
    this.timesheetService.exportTimesheet(filterData, userId)
      .subscribe(response => {
        if (response.responseObject != undefined && response.responseObject != null && response.responseObject != '') {
          saveAs(this.exportData.base64ToBlob(response.responseObject), 'timeSheet_' + this.formatedDate);
        }
        this.snackBar.open(response.message, 'Close', { duration: 3000 });
        this.isExcelBeingDownloaded.emit(false);
      }, error => {
        this.isExcelBeingDownloaded.emit(false);
        this.snackBar.open(error.message, 'Close', { duration: 3000 });
      });

  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getTimesheets();
  }

  clearFilter() {
    this.filterForm.reset({ workDate: '', categoryIds: [], activityIds: [], userIds: [], startDate: moment(), endDate: moment() });
    this.getTimesheets();
  }

  editTimesheet(timesheet: Timesheet): void {
    this.activities = [];
    timesheet.editing = true;
    this.timesheets.map(
      sheet => {
        if (sheet.id != timesheet.id) {
          sheet.editing = false;
        }
      }
    );
    if (this.activities.length == 0) {
      let type = this.categoryList.find(x => x.id == timesheet.categoryId)?.categoryTypeId ?? 0;
      this.getActivityListByCategoryType(type)
    }
  }

  cancelEdit(timesheet: Timesheet): void {
    timesheet.editing = false;
    this.getTimesheets();
  }

  saveTimesheet(timesheet: Timesheet): void {
    if (timesheet.activityId == -1) {
      this.snackBar.open('activity is required.', 'Close', { duration: 3000 });
      return;
    }
    if (Number(timesheet.noOfHours) > 10) {
      this.snackBar.open('Hours should not exceed 10.', 'Close', { duration: 3000 });
      return;
    }
    if (Number(timesheet.noOfHours)) {
      timesheet.noOfHours = Number(Number(timesheet.noOfHours).toFixed(2));
    }
    if (timesheet && timesheet.id) {
      const workDateValue: Date | null = timesheet.workDate;
      if (workDateValue) {
        timesheet.workDate = new Date(formatDate(workDateValue, 'yyyy-MM-dd', 'en'));
      }
      // this.timesheetService.updateTimesheet(timesheet).subscribe((res: any) => {
      //   this.snackBar.open(res.message, 'Close', { duration: 3000 });
      //   timesheet.editing = false;
      //   this.getTimesheets();
      // },(error: any) => this.handleError(error, 'Failed to update timesheet'));
      this.timesheetService.updateTimesheet(timesheet).subscribe({
        next: (res: ResponseBase<Timesheet>) => {
          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
          timesheet.editing = false;
          this.getTimesheets();
        },
        error: (err: HttpErrorResponse) => {
          this.handleError(err, 'Failed to update timesheet');
        }
      });
    }
  }

  deleteTimesheet(id: number): void {
    if (confirm('Are you sure you want to delete this timesheet?')) {
      // this.timesheetService.deleteTimesheet(id).subscribe((res: any) => {
      //   this.snackBar.open(res.message, 'Close', { duration: 3000 });
      //   this.getTimesheets();
      //   // this.timesheetUpdated.emit();
      // },(error: any) => this.handleError(error, 'Failed to delete timesheet'));
      this.timesheetService.deleteTimesheet(id).subscribe({
        next: (res: ResponseBase<Timesheet>) => {
          this.snackBar.open(res.message, 'Close', {duration: 3000});
          this.getTimesheets();
        },
        error: (err: HttpErrorResponse) => {
          this.snackBar.open(err.message, 'Close', {duration: 3000});
        }
      })
    }
  }

  getActivityList(categoryId: number) {
    let type = this.categoryList.find(cat => cat.id == categoryId)?.categoryTypeId;
  }

  formatTime(time: string): string {
    const timeParts = time.split(':');
    if (timeParts.length === 2) {
      return `${timeParts[0].padStart(2, '0')}:${timeParts[1].padStart(2, '0')}:00`;
    } else {
      return time;
    }
  }

  onCategorySelection(id: any, timesheetId: any) {
    let categoryTypeId = this.categoryList.find(category => category.id == id)?.categoryTypeId ?? 0;
    const timesheet = this.timesheets.find(x => x.id == timesheetId);
    if (timesheet) {
      timesheet.activityId = -1;
    }
    this.getActivityListByCategoryType(categoryTypeId);
  }

  onfilterCategorySelection(categoryIds: number[]): void {
    if (categoryIds && categoryIds.length > 0) {
      const categoryTypeIds = this.categoryList.filter(c => categoryIds.includes(c.id)).map(category => category.categoryTypeId);
      this.getFilterActivityList(categoryTypeIds);
    } else {
      this.filterActivityList = [];
      this.filterForm.get('activityIds')?.reset();
    }
  }

  getFilterActivityList(categoryTypeIds: number[]): void {
    this.activityService.getActivityByCategoryTypeIds(categoryTypeIds).subscribe({
      next: (res: ResponseCommonForList<Activity>) => {
        this.filterActivityList = res.responseObject;
        this.activitySearch.setOptions(this.filterActivityList.map((a: IdName) => ({id: a.id, name: a.name})));
        if (this.filterActivityList.length == 1 && this.filterForm.get("categoryIds")?.value != null) {
          this.filterForm.get("activityIds")?.setValue(this.filterActivityList[0].id)
        } else {
          this.filterForm.get("activityIds")?.reset()
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting activityList by categoryTypeIds : ", err.message);
      }
    });
  }


  getActivityListByCategoryType(categoryTypeId: number): void {
    this.activityService.getActivityByCategoryTypeId(categoryTypeId).subscribe({
      next: (res: ResponseCommonForList<Activity>) => {
        this.activities = res.responseObject;
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting Activities By CategoryTypeId:", err.message);
      }
    });
  }

  // onCategoryChange(event: any) {
  //   let categoryTypeId = this.categoryList.find(x => x.id == event.value)?.categoryTypeId;
  //   this.getActivityListByCategoryType(categoryTypeId);
  // }

  private handleError(error: any, message: string): void {
    this.snackBar.open(`${message}. Please try again.`, 'Close', { duration: 3000 });
  }

  onFilter(): void {
    this.getTimesheets();
  }

  getTotalCost() {
    // return this.timesheets.map(t => t.noOfHours).reduce((acc:any, value:any) => acc + value, 0);
    const totalHours = this.timesheets.map(t => t.noOfHours).reduce((acc: any, value: any) => acc + value, 0);
    return totalHours.toFixed(2);
  }

  onSelectAll(event: any) {
    if (this.timesheets) {
      for (let index = 0; index < this.timesheets.length; index++) {
        this.timesheets[index].completed = event.checked
        this.isSelectAll = true
      }
    }
  }

  update(event: any, index: number) {
    this.timesheets[index].completed = event.checked
    if (this.timesheets) {
      for (let timeIndex = 0; timeIndex < this.timesheets.length; timeIndex++) {
        if (!this.timesheets[timeIndex].completed) {
          this.isSelectAll = false
          break
        } else {
          this.isSelectAll = true
        }
      }
    }
  }

  onStatusChange(event: any, timeSheetData: any) {
    let status: number = 0
    let message: string = ""
    if (event.checked) {
      status = 1
      message = TIMESHEET_STATUS_VERIFIED
    } else {
      message = TIMESHEET_STATUS_UN_VERIFIED
    }
    let confirmMsg = confirm(message)
    if (confirmMsg) {
      const startedDate = this.filterForm.get('startDate')?.value; // Get the startDate
      const endedDate = this.filterForm.get('endDate')?.value; // Get the endDate
      let filters: any = {
        userId: this.userData.id,
        status: status,
        ids: [timeSheetData.id]
      }
      this.timesheetService.statusTimesheet(filters).subscribe((res: any) => {
        // this.filterForm.patchValue({ categoryIds : [], activityIds: [], userIds: this.isAdmin ? -1 : this.userData.id });
        this.filterForm.patchValue({ categoryIds: [this.filterForm.get('categoryIds')?.value], activityIds: [this.filterForm.get('activityIds')?.value], userIds: this.isAdmin ? [this.filterForm.get('userIds')?.value] : [this.filterForm.get('userIds')?.value] });
        this.getTimesheets()
        this.snackBar.open(res.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
        this.filterForm.patchValue({
          startDate: startedDate,
          endDate: endedDate
        });
      });
    } else {
      if (event.checked) {
        event.source._checked = false
      } else {
        event.source._checked = true
      }
    }
  }


  setTimeSheetStatus(status: number) {
    let message: string = "";
    for (let index = 0; index < this.timesheets.length; index++) {
      if (!this.timesheets[index].completed) {
        if (status == 1) {
          this.snackBar.open('Please Select Task Row To Verify', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        } else {
          this.snackBar.open('Please Select Task Row To UnVerify', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      } else {
        if (status == 0) {
          message = TIMESHEET_STATUS_ALL_UN_VERIFIED;
        } else {
          message = TIMESHEET_STATUS_ALL_VERIFIED;
        }

        let confirmMsg = confirm(message);
        if (confirmMsg) {
          const startedDate = this.filterForm.get('startDate')?.value; // Get the startDate
          const endedDate = this.filterForm.get('endDate')?.value; // Get the endDate
          let userId: any;
          let ids: any[] = [];
          let filters: any = {
            status: status
          };

          if (this.timesheets) {
            for (let index = 0; index < this.timesheets.length; index++) {
              if (this.timesheets[index].completed) {
                if (this.timesheets[index].userId == this.userData.id) {
                  continue;
                }
                ids.push(this.timesheets[index].id);
                userId = this.userData.id;
              }
            }
            filters.userId = userId;
            filters.ids = ids;
          }

          this.timesheetService.statusTimesheet(filters).subscribe((res: any) => {
            this.filterForm.patchValue({
              categoryId: '-1',
              activityId: '-1',
              userId: this.isAdmin ? -1 : this.userData.id
            });
            this.getTimesheets();
            this.snackBar.open(res.message, 'Close', {
              duration: 3000,
              verticalPosition: 'bottom',
              horizontalPosition: 'center'
            });
            this.filterForm.patchValue({
              startDate: startedDate,
              endDate: endedDate
            });
          });
        }
        break;
      }
    }
  }


  precision($event: Event) {
    const element = $event.target as HTMLInputElement;
    if (element.value) {
      element.value = parseFloat(element.value).toFixed(2);
    }
  }

  // selectedActivityIds: number[] = [];

  // onActivitySelectionChange(ids: number[]) {
  //   this.selectedActivityIds = ids;
  //   this.filterForm.get('activityIds')?.setValue(this.selectedActivityIds);
  // }

  // selectedCategoryIds: number[] = [];
  // onCategorySelectionChange(categoryIds: number[]) {
  //   this.selectedCategoryIds = categoryIds;
  //   this.filterForm.get('categoryIds')?.setValue(this.selectedCategoryIds);
  //   if (categoryIds && categoryIds.length > 0) {
  //     const categoryTypeIds = this.categoryList.filter( c => categoryIds.includes(c.id)).map(category => category.categoryTypeId);
  //     this.getFilterActivityList(categoryTypeIds);
  //     this.filterForm.get('categoryIds')?.setValue(this.selectedCategoryIds);
  //   } else {
  //     this.filterActivityList = [];
  //     this.filterForm.get('activityIds')?.reset();
  //   }
  // }

  // selectedUserIds: number[] = [];
  // onUserSelectionChange(ids: number[]) {
  //   this.selectedUserIds = ids;
  //   this.filterForm.get('userIds')?.setValue(this.selectedUserIds);
  // }

  // selectedStatusIds: number[] = []
  // onStatusSelection(sIds: number[]) {
  //   this.selectedStatusIds = sIds;
  //   this.filterForm.get('status')?.setValue(this.selectedStatusIds);
  // }
}
